import {createOpnChargeMutation} from './create-opn-charge.mutation'
import {getTerminalQuery} from './get-terminal'
import {getCheckoutIdQuery, getPaymentCheckoutIdQuery} from './get-tp-checkout'
import {UpdateEntityForPayMutation} from './update-entity-for-pay.mutation'

export const PaymentsQueries = {getCheckoutIdQuery, getTerminalQuery, getPaymentCheckoutIdQuery}
export const PaymentsMutations = {createOpnChargeMutation, UpdateEntityForPayMutation}
